import { render, staticRenderFns } from "./index.vue?vue&type=template&id=409c9558&scoped=true&"
import script from "./cardNews.js?vue&type=script&lang=js&"
export * from "./cardNews.js?vue&type=script&lang=js&"
import style0 from "./cardNews.scss?vue&type=style&index=0&id=409c9558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409c9558",
  null
  
)

export default component.exports